'use client';

import loyalty from '@/assets/loyalty_white.png';
import AppStorage from '@/utils/helpers';
import Image from 'next/image';
import { useRouter } from 'next/navigation';

export default function HomeLoyaltyFab() {
  const router = useRouter();

  const gotoLoyalty = () => {
    AppStorage.save('redirect', true);
    router.push('/account');
  };

  return (
    <button
      onClick={gotoLoyalty}
      className="fixed bottom-10 right-3 px-6 py-3 rounded-full shadow-lg bg-crunchies-red z-50"
    >
      <span className="flex items-center gap-2">
        <Image src={loyalty} alt="loyalty badge" className="w-5 h-5" />
        <span className="text-sm font-medium text-white">
          Earn Loyalty Points
        </span>
      </span>
    </button>
  );
}
